<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-row>
        <a-col :span="8">
          <div class="title-box">
            <p>人员</p>
            <user-select v-model:value="formState.employeeNo" style="width: 80%" @change="fetchData" />
          </div>
        </a-col>
        <a-col :span="8">
          <div class="title-box">
            <p>时间</p>
            <a-date-picker
              style="width: 80%"
              v-model:value="formState.date"
              :allowClear="false"
              @change="fetchData"
              picker="month"
            />
          </div>
        </a-col>
      </a-row>
      <!-- <CosViewContent> -->
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="销售线索&商机">
          <Tab1 :formState="formState" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="客户过程管理">
          <CustomerDataBoardComponent :formState="formState" />
        </a-tab-pane>
        <a-tab-pane key="3" tab="客户营收管理">
          <CustomerRevenueManagement :formState="formState" :employeeNo="formState.employeeNo" />
        </a-tab-pane>
        <a-tab-pane key="4" tab="客户风控管理">
          <Tab4 :formState="formState" />
        </a-tab-pane>
      </a-tabs>
      <!-- </CosViewContent> -->
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Tab1 from './tab1.vue'
import Tab4 from './tab4.vue'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'
import CustomerDataBoardComponent from '@/views/gucangSales/dataBoard/componects/CustomerDataBoardComponent.vue'
import CustomerRevenueManagement from '@/views/gucangSales/dataBoard/componects/CustomerRevenueManagement.vue'
import { shareInfo } from '@dc-platform/dc-interaction'

interface FormState {
  employeeNo?: string
  dataPermissionQueryType: number
  date: dayjs.Dayjs
}

const formState = ref<FormState>({
  dataPermissionQueryType: 2,
  employeeNo: shareInfo.getUserInfo().work_code,
  date: dayjs(),
  startDay: dayjs().startOf('month').format('YYYY/MM/DD'),
  endDay: dayjs().endOf('month').format('YYYY/MM/DD')
})

const fetchData = () => {
  const p = { ...formState.value }
  const { employeeNo, date } = formState.value
  p.dataPermissionQueryType = employeeNo !== undefined ? 2 : 1
  p.startDay = dayjs(date).startOf('month').format('YYYY/MM/DD')
  p.endDay = dayjs(date).endOf('month').format('YYYY/MM/DD')
  // followingUpRateListParam.value.endDay = dayjs(followingValue.value).endOf('month').format('YYYY/MM/DD')
  formState.value = p
}
</script>

<script lang="ts">
export default { name: 'DcCosFbuDataBoard' }
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: #fff;
  width: 100%;
  height: 50px;
  p {
    color: #666666;
    font-size: 14px;
    font-weight: 500;
    margin-right: 6px;
  }
  .input {
    width: 350px;
    background: #f9f9ff;
    border-radius: 4px;
    border: none;
    margin-left: 18px;
  }
}
</style>
